import { forwardRef } from "react";

import { observer } from "mobx-react";

import { BasicInput, BasicInputProps } from "../BasicInput";

export interface NumberInputProps extends BasicInputProps {
  type: "number";
}

export const NumberInput = observer(
  forwardRef<HTMLInputElement, NumberInputProps>(function NumberInput(
    props,
    ref
  ) {
    return <BasicInput ref={ref} {...props} />;
  })
);
